<template>
  <div class="about">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1>About Us</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p>In 2018, the North Coast Health Improvement and Information Network (NCHIIN) was awarded funding from the Well Being Trust to implement a project with various goals related to improving health outcomes for pregnant women with substance use disorders (SUD). Among those goals was to develop an online, mobile-friendly resource guide specific to the perinatal population. Realizing that a resource like this has utility beyond one specific population, the NCHIIN team has worked to incorporate various community resources into the  “North Coast Resource Hub.”  .  Currently, the primary audience for the North Coast Resource Hub is social workers, case managers, and other service providers working with clients with complex needs.</p>
          <p>The North Coast Resource Hub is a tool in its beginning stages. The design team plans for continued development and exploration on how to grow the resource to best meet the needs of the community. Future plans include continued addition of local resources, creating content geared toward the layperson, and more user-friendly features.</p>
          <p>If you have comments, questions, or suggestions about the North Coast Resource Hub, please contact Kerri Gowdy, Project Manager, at <a href="mailto:kgowdy@nchiin.org?Subject=Resource%20Hub%20Inquiry">kgowdy@nchiin.org</a> or 707-443-4563 x 157</p>
        </div>
      </div>
    </div>
    <div class="container" id="about-logos">
      <div class="row">
        <div class="col"><img class="logo-img" style="width: 100%;" src="@/assets/nchiin.png" alt="North Coast Health Improvement and Information Network"></div>
      </div>
      <div class="row">
        <div class="col"><img class="logo-img" style="width: 400px;" src="@/assets/rise.jpg" alt="Humboldt RISE Project"></div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'About',
  };
</script>

<style>
  .logo-img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    max-width: 500px;
    max-height: 250px;
  }
</style>